import { render } from "./TokenGuide.vue?vue&type=template&id=33b54a5b&scoped=true"
import script from "./TokenGuide.vue?vue&type=script&lang=js"
export * from "./TokenGuide.vue?vue&type=script&lang=js"

import "./TokenGuide.vue?vue&type=style&index=0&id=33b54a5b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b54a5b"]])

export default __exports__